import { useState } from 'react';
import { Typography, Stack, Button, Alert } from '@mui/material';

import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import exportFromJSON from 'export-from-json';

import { getAllPlaytime } from '../../services/Playtime';
import { getFormattedDate } from '../../utils/Date';

const ExportToCSV = () => {
  const [exportAlert, setExportAlert] = useState({ open: false });
  const [dates, setDates] = useState({ from: null, to: null });

  const exportToCSV = async () => {
    let playtime = null;
    await getAllPlaytime(dates.from, dates.to).then((response) => {
      // convert dates from firebase format to readable dates
      playtime = response.map((item) => ({
        ...item,
        date: getFormattedDate(new Date(item.date.seconds * 1000)),
        registered: getFormattedDate(new Date(item.registered.seconds * 1000)),
      }));
    });
    if (playtime !== null && playtime.length > 0) {
      exportFromJSON({
        data: playtime,
        fileName: 'Fotballyst Spilletid',
        exportType: exportFromJSON.types.xls,
      });
      setExportAlert({ open: true, type: 'success', message: 'Eksporterte til CSV. Nedlastningen starter automatisk' });
    } else {
      setExportAlert({
        open: true,
        type: 'error',
        message: 'Kunne ikke eksportere. Fant ingen registreringer som passet med intervallet',
      });
    }
  };

  return (
    <div>
      <Typography variant="body1" gutterBottom>
        Eksporter spillerresultater til CSV.
      </Typography>
      <Stack spacing={2} mt={3}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Fra dato"
            value={dates.from}
            maxDate={new Date()}
            inputFormat="dd.MM.yyyy"
            onChange={(newValue) => {
              setDates({ ...dates, from: newValue });
            }}
            renderInput={(params) => <TextField fullWidth {...params} />}
          />
          <DatePicker
            label="Til dato"
            value={dates.to}
            maxDate={new Date()}
            inputFormat="dd.MM.yyyy"
            onChange={(newValue) => {
              setDates({ ...dates, to: newValue });
            }}
            renderInput={(params) => <TextField fullWidth {...params} />}
          />
        </LocalizationProvider>
        <Button onClick={() => exportToCSV()} variant="contained" color="primary" size="large">
          Eksporter til CSV
        </Button>
        {exportAlert.open && <Alert severity={exportAlert.type}>{exportAlert.message}</Alert>}
      </Stack>
    </div>
  );
};

export default ExportToCSV;
